import { forwardRef } from "react";
import type { HTMLAttributes, CSSProperties, Ref } from "react";
import { cn } from "../../../styles";
import type { LayoutHeight, LayoutWidth } from "../types";

interface LayoutContainerProps extends HTMLAttributes<HTMLDivElement> {
  height?: LayoutHeight;
  width?: LayoutWidth;
  style?: CSSProperties;
}

function LayoutContainerInner(
  { children, className, height, width = "fill", style, ...props }: LayoutContainerProps,
  ref: Ref<HTMLDivElement>,
) {
  const isFill = height === "fill" || typeof height === "number";

  return (
    <div
      {...props}
      ref={ref}
      className={cn(
        "flex flex-col items-stretch overflow-visible min-w-0",
        isFill && "fill h-full grow [&>.portal]:h-full",
        height === "content" && "full-height",
        width === "content" && "content-width",
        className,
      )}
      style={typeof height === "number" ? { ...style, height } : style}
    >
      {children}
    </div>
  );
}

export const LayoutContainer = forwardRef(LayoutContainerInner);
